'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Container, Grid, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

import { engagementModels } from '@/config/engagement-models.config';
import colors from '@/styles/themes/colors';
import useScrollReveal from '@/utils/hooks/useScrollReveal';

import EngagementModelCard from './EngagementModelCard';
import styles from './EngagementModelsSection.module.scss';

const EngagementModelsSection = () => {
  const t = useTranslations('common.engagementModelsSection');
  const { setRef, isVisible } = useScrollReveal<HTMLDivElement>(engagementModels.length);

  return (
    <Container component="section" maxWidth="xl" classes={{ root: styles.root }} className={styles.container}>
      <Typography variant="h2" textAlign="center" maxWidth={804}>
        {t('title')}
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        color={colors.graytone300}
        mt={{ xs: 3, md: 4 }}
        maxWidth={692}
        mx="auto"
      >
        {t('description')}
      </Typography>
      <Grid container spacing={{ xs: 8, md: 3 }} mt={{ xs: 6, md: 10 }} className={styles.grid}>
        {engagementModels.map((model, index) => (
          <Grid size={{ xs: 12, md: 6 }} key={model.id}>
            <Box
              ref={setRef(index)}
              className={cx(styles.card, {
                [styles.visibleLeft]: isVisible(index) && index === 0,
                [styles.visibleRight]: isVisible(index) && index === 1,
              })}
            >
              <EngagementModelCard
                model={model}
                title={t(model.titleKey as any)}
                description={t(model.descriptionKey as any)}
                features={t.raw(model.featuresKey as any) as string[]}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default EngagementModelsSection;
